import React from 'react';
import styled from 'styled-components';
import Text from '@text';
import themedFontSize from '../../../../styles/theme/themed-font-size';
import themedColor from '../../../../styles/theme/themed-color';
import styleUtils from '../../../../styles/style.utils';

interface FormValidationErrorProps {
  errorMessage?: string;
  defaultError?: string;
}

const FormValidationError: React.FunctionComponent<FormValidationErrorProps> = ({
  errorMessage
}) => {
  return (
    <ErrorMessage>
      <Text tParams={errorMessage} />
    </ErrorMessage>
  );
};

const ErrorMessage = styled.div`
  color: ${themedColor('ERROR')};
  font-size: ${themedFontSize('ERROR')};
  margin: ${styleUtils.px(4)} 0;

  p {
    margin: 0;
    padding: 0;
    color: ${themedColor('ERROR')};
    font-size: ${themedFontSize('ERROR')};
  }
`;

export default FormValidationError;
